(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.DreamWhisperSelection = api;
})(typeof window !== 'undefined' ? window : null, function () {
  function toggleSelection(selection, ids) {
    const next = new Set(selection);
    const uniqueIds = [...new Set(ids)];
    const shouldSelect = uniqueIds.some((id) => !next.has(id));
    uniqueIds.forEach((id) => shouldSelect ? next.add(id) : next.delete(id));
    return next;
  }

  function applyColor(colors, selection, resolveTargets, colorId) {
    const next = { ...colors };
    for (const id of selection) {
      for (const target of resolveTargets(id)) next[target] = colorId;
    }
    return next;
  }

  function applyColorAndClearSelection(colors, selection, resolveTargets, colorId) {
    return {
      colors: applyColor(colors, selection, resolveTargets, colorId),
      selected: new Set(),
    };
  }

  function clearSelectedColors(colors, selection, resolveTargets) {
    const next = { ...colors };
    for (const id of selection) {
      for (const target of resolveTargets(id)) delete next[target];
    }
    return next;
  }

  return { toggleSelection, applyColor, applyColorAndClearSelection, clearSelectedColors };
});
